export default __webpack_public_path__ + "static/media/photo--lg--123.835ad85e.jpg";